export const ALL_ROUTES = {
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  // -----auth end here --------------------

  DASHBOARD_OVERVIEW: "/dashboard",
  DASHBOARD_TRANSACTION: "/transaction",
  DASHBOARD_TRANSACTION_MOBILE: "/transaction-mobile",
  DASHBOARD_TRANSACTION_WEB: "/transaction-web",
  DASHBOARD_TRANSACTION_BUSINESS: "/transaction-business",
  DASHBOARD_TRANSACTION_ZOJAPAY: "/transaction-zojapay",
  DASHBOARD_TRANSACTION_BRIDGE: "/transaction-bridge",
  DASHBOARD_TRANSACTION_STRIPE: "/transaction-stripe",
  DASHBOARD_TRANSACTION_PLAID: "/transaction-plaid",
  DASHBOARD_TRANSACTION_QUEUING: "/transaction-queuing",
  DASHBOARD_TRANSACTION_DETAILS: "/transaction-details",
  DASHBOARD_CUSTOMER: "/customers-personal",
  DASHBOARD_CUSTOMER_WEB: "/customers-web",
  DASHBOARD_CUSTOMER_BUSINESS: "/customers-business",
  DASHBOARD_DELETED_CUSTOMERS: "/customers-deleted",
  DASHBOARD_FEATURE_MANAGEMENT: "/feature-management",
  DASHBOARD_FEATURE_MANAGEMENT_DETAILS: "/feature-management-details",
  DASHBOARD_CUSTOMER_SINGLE: "/customers-single",
  DASHBOARD_SETTINGS_EXCHANGE_RATE: "/settings-exchange-rate",
  DASHBOARD_SETTINGS_EXCHANGE_RATE_HISTORY: "/settings-exchange-rate-history",
  DASHBOARD_SETTINGS: "/settings",
  DASHBOARD_SETTINGS_PROFILE: "/settings-profile",
  DASHBOARD_SETTINGS_ACCOUNT: "/settings-account",
  DASHBOARD_SETTINGS_NOTIFICATION: "/settings-notification",
  DASHBOARD_SETTINGS_NOTIFICATION_CREATE: "/settings-notification-create",
  DASHBOARD_SETTINGS_ANNOUNCEMENT: "/settings-announcement",
  DASHBOARD_SETTINGS_MANAGE_FEATURE: "/settings-manage-feature",
  DASHBOARD_SETTINGS_APPROVAL: "/settings-approval",
  DASHBOARD_ROLES: "/roles",
  DASHBOARD_ROLES_ADD: "/roles-add",
  DASHBOARD_ROLES_VIEW: "/roles-view",
  DASHBOARD_ROLES_EDIT: "/roles-edit",
  DASHBOARD_USERS: "/users",
  DASHBOARD_USER_ACTIVITY: "/user-activity",
  DASHBOARD_THIRD_PARTY: "/third-party-app",
  DASHBOARD_THIRD_PARTY_PAYAZA: "/third-party-app-payaza",
  DASHBOARD_THIRD_PARTY_BLAZE: "/third-party-app-blaze",
  DASHBOARD_THIRD_PARTY_BRIDGE: "/third-party-app-bridge",
  DASHBOARD_THIRD_PARTY_ZOJAPAY: "/third-party-app-zojapay",
  DASHBOARD_THIRD_PARTY_CONTROL_PANEL: "/third-party-control-panel",

  DASHBOARD_REPORT: "/report",
  DASHBOARD_REPORT_HISTORY: "/report-history",
  DASHBOARD_EXPORT: "/exports",
  DASHBOARD_EXPORT_CREATE: "/exports/create",
  DASHBOARD_EXPORT_EDIT: "/exports/edit",
  DASHBOARD_LEDGER: "/ledger",
  DASHBOARD_LEDGER_DETAILS: "/ledger-details",

  DASHBOARD_REFERRAL: "/referral",
  DASHBOARD_REFERRAL_CREATE_CAMPAIGN: "/referral/create-campaign",
  DASHBOARD_REFERRAL_EDIT_CAMPAIGN: "/referral/edit-campaign",
  DASHBOARD_REFERRAL_VIEW_CAMPAIGN: "/referral/view-campaign",
  DASHBOARD_REFERRAL_INFLUENCER_APPLICATION: "/referral/influencer-application",

  DASHBOARD_NOTIFICATION_MANAGEMENT: "/notification-management",
  DASHBOARD_NOTIFICATION_MANAGEMENT_CREATE: "/notification-management/create",
  DASHBOARD_NOTIFICATION_MANAGEMENT_VIEW: "/notification-management/view",

  DASHBOARD_RATE_INTELLIGENCE: "/rate-intelligence",
};
